var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-body',[_c('TextEditor',{attrs:{"entity":_vm.entity,"label":"Navn","alias":"5d139c4a0512d063ecf457fe","validate":true,"scope":"module"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }